<template>
    <div class="__l">
        <h1 class="title">Account Groups</h1>
        <div class="actions right text-right">
            <button class="btn-primary" type="button" @click="createGroup">Create Account Group</button>
        </div>
        <input type="text" v-model="search" class="form-field py-4 px-6" ref="searchbar"
               placeholder="Search for Account Groups" @keyup.enter="handleSearch">

        <div class="results-list">
            <div class="results-row">
                <div class="results-head" data-width="10%">ID</div>
                <div class="results-head" data-width="70%">Name</div>
                <div class="results-head" data-width="20%">Members</div>
            </div>
            <template v-if="results.data">
                <div class="results-row" v-for="(result, index) in results.data" :key="index"
                     @click="handleSelected(result)">
                    <div class="results-cell" data-width="10%">{{ result.id }}</div>
                    <div class="results-cell truncate" data-width="70%">{{ result.name }}</div>
                    <div class="results-cell" data-width="20%">{{ result.accounts_count }}</div>
                </div>
                <pagination v-model="page" :records="results.total" :per-page="25"
                            @paginate="loadData"></pagination>
            </template>
            <div class="results-row" v-if="!results.data">
                <div class="results-span text-center" data-width="100%">
                    <p>No results found</p>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
import AccountGroupView from './View'
import Pagination from 'v-pagination-3'

export default {
    name: 'AccountGroups',
    props: {
        //
    },
    data() {
        return {
            search: null,
            results: {},
            page: 1,
        }
    },
    components: {
        Pagination,
        AccountGroupView,
    },
    mounted() {
        window.setTimeout(function () {
            this.$refs.searchbar.focus()
        }.bind(this), 100)

        this.setMetaTitle('Account Groups | JournoLink Control')
    },
    methods: {
        handleSearch() {
            this.loadData()
        },
        /**
         * Load the results from the data provider
         *
         * @return {void}
         */
        loadData() {
            axios.get(route('accountGroups.list'), {
                params: {
                    term: this.search,
                    page: this.page,
                },
            })
                .then(response => {
                    this.results = response.data.results
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Handle the selection of a AccountGroup
         *
         * @param  {Object} record
         * @return {void}
         */
        handleSelected(record) {
            this.$router.push({name: 'accountgroups.show', params: {id: record.id}})
        },
        /**
         * Create a new AccountGroup
         *
         * @return {void}
         */
        createGroup() {
            this.$router.push({name: 'accountgroups.create'})
        }
    },
    beforeRouteUpdate(to, from, next) {
        if (to && to.name === 'accountgroups.list') {
            this.setMetaTitle('Account Groups | JournoLink Control')
            this.loadData()
        }

        if (to && to.params.newRecord) {
            window.setTimeout(() => {
                this.handleSelected(to.params.newRecord)
            }, 500)

            next()
        }

        next()
    },
}
</script>

<style lang="less">

</style>
